<template>
  <div>
    <table class="tw-table-auto">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column"
          >
            {{ column }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(row, i) in tableData"
          :key="i"
        >
          <td
            v-for="column in columns"
            :key="column"
          >
            {{ row[column] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ChartClickthroughs',
  components: { /* Subcomponents */ },
  props: {
    clickData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    initTableData: {
      type: Array,
      required: false,
      default: () => ([
        { name: 'John', age: 21, gender: 'male' },
        { name: 'Jane', age: 23 },
        { name: 'Joe', age: 22 },
      ]),
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    columns() {
      // Get a list of all keys occuring at least once in the table data rows
      const keys = this.tableData.reduce((acc, row) => {
        Object.keys(row).forEach((key) => {
          if (!acc.includes(key)) {
            acc.push(key);
          }
        });
        return acc;
      }, []);
      return keys;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
    this.tableData = this.initTableData;
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
table, th, td {
  border: 1px solid #ddd;
}
th, td {
  text-align: left;
  padding: 8px;
}
th {
  background-color: #f2f2f2;
}
tr:hover {
  background-color: #f5f5f5;
}
td {
  text-align: center;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>

